module.exports = __webpack_public_path__ + "static/media/restaurant-5.a37815dd.jpg";